export const safelyGetWindow = (): typeof window => (typeof window !== 'undefined' ? window : undefined)
export const isLocalhost = () => safelyGetWindow()?.location.hostname === 'localhost'
